import { http } from '../../utils/http'
export const UABASE = window.$envUtils('VUE_APP_AFF_SERVICE')

// 增加表单触发
export const addFormTrigger = (data) => {
  return http.post(`${UABASE}/formTrigger/trigger`, { data })
}

// 删除表单触发
export const deleteFormTrigger = (params) => {
  return http.delete(`${UABASE}/formTrigger/trigger`, { params })
}

// 修改表单触发
export const updateFormTrigger = (data) => {
  return http.put(`${UABASE}/formTrigger/trigger`, { data })
}

// 根据faqId集查询表单触发
export const selectFormTrigger = (params) => {
  return http.get(`${UABASE}/formTrigger/triggerList`, { params })
}
